import React, {useState} from 'react';
import {useNavigation} from 'react-router-dom';
import {SideMenu} from '../SideMenu';
import {ContentLayout} from '../ContentLayout';
import {Layout} from 'antd';
import {HeaderLayout} from '../HeaderLayout';

const MainLayout = () => {
  const navigation = useNavigation();

  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout className={'main-layout-container'}>
      <SideMenu collapsed={collapsed} onClick={() => setCollapsed(!collapsed)} />
      <Layout className={'main-header-and-content-container'}>
        <HeaderLayout />
        <ContentLayout navigation={navigation} />
      </Layout>
    </Layout>
  );
};

export default MainLayout;
